import React, { useContext } from "react";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PublicIcon from "@mui/icons-material/Public";
import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";

import * as api from "../../services";
import { useGetSeachParam } from "../../useSearchParams";
import useActiveContexts from "../useActiveContexts";
import ActionButtonDialog from "../../Components/ActionButtonDialog";
import LibraryContext from "../libraryContext";
import useAccountSettings from "../../ManageAccount/useAccountSettings";
import AppContext from "../../appContext";

function ShareDialog({
  open,
  publicStatus,
  setOpen,
  refetchPublicInteraction,
}) {
  const { t } = useTranslation();
  const {
    app: {
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const interactionId = Number(useGetSeachParam("i"));
  const { handleQuery } = useContext(LibraryContext);
  // server state
  const { accountSettings } = useAccountSettings();
  const { libraryContexts } = useActiveContexts();
  const shareMutation = useMutation(
    (newPublicStatus) =>
      api.sharePublicInteraction({
        id: interactionId,
        publicStatus: newPublicStatus,
        projectId,
        sessionId,
      }),
    {
      onSuccess: (data) => {
        if (data.data?.status > 0) {
          // close the shareDialog
          setOpen((prev) => ({ ...prev, open: false }));
          handleQuery({ type: "refresh" }); // rerender the list of surveys
          refetchPublicInteraction(); // rerender the interaction
        }
      },
    }
  );
  const handleClick = (newPublicStatus) =>
    shareMutation.mutate(newPublicStatus);
  const defaultButtons = [
    {
      id: 0,
      primaryText: t("library.shareDialog.none"),
      icon: <LockOutlinedIcon />,
      onClick: () => handleClick(0),
      disabled: false,
    },
    {
      id: 1,
      primaryText: t("library.shareDialog.public"),
      icon: <PublicIcon />,
      onClick: () => handleClick(1),
      disabled: accountSettings.disablePublicLibrary,
    },
  ];
  const groupButtons = libraryContexts.map((context) => ({
    id: context.contextId,
    primaryText: context.name,
    icon: <FolderSharedOutlinedIcon />,
    onClick: () => handleClick(context.contextId),
    disabled: false,
  }));
  const buttons = [
    ...defaultButtons.filter((button) => !button.disabled),
    ...groupButtons.filter((button) => !button.disabled),
  ];

  return (
    <ActionButtonDialog
      open={open}
      setOpen={setOpen}
      dialogTitle={t("library.shareDialog.title")}
      dialogContentText=""
      buttons={buttons}
      selectedButtonId={publicStatus}
    />
  );
}

export default ShareDialog;
